webpackJsonp([66982970260863],{

/***/ 883:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/BP_GH2.7c5f8d48.jpg";

/***/ }),

/***/ 300:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _info = __webpack_require__(7);
	
	var _info2 = _interopRequireDefault(_info);
	
	var _BP_GH = __webpack_require__(883);
	
	var _BP_GH2 = _interopRequireDefault(_BP_GH);
	
	var _panoramic = __webpack_require__(24);
	
	var _panoramic2 = _interopRequireDefault(_panoramic);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function () {
	    return _react2.default.createElement(
	        _panoramic2.default,
	        null,
	        _react2.default.createElement(
	            'div',
	            { className: 'metadata--wrapper' },
	            _react2.default.createElement('img', { src: _BP_GH2.default, alt: '' }),
	            _react2.default.createElement(
	                _info2.default,
	                null,
	                'View of the city of Quebec taken from the North Side of the St. Charles (ca 1790). Gravure de J.C. Stadler, Travels Through the Canadas, 1807.'
	            )
	        )
	    );
	};
	
	module.exports = exports['default'];

/***/ }),

/***/ 353:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(3);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _reactHelmet = __webpack_require__(11);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _flexContainer = __webpack_require__(8);
	
	var _flexContainer2 = _interopRequireDefault(_flexContainer);
	
	var _sidebarLeft = __webpack_require__(12);
	
	var _sidebarLeft2 = _interopRequireDefault(_sidebarLeft);
	
	var _sidebarRight = __webpack_require__(13);
	
	var _sidebarRight2 = _interopRequireDefault(_sidebarRight);
	
	var _container = __webpack_require__(6);
	
	var _container2 = _interopRequireDefault(_container);
	
	var _imageFooterUneVilleFabulee = __webpack_require__(300);
	
	var _imageFooterUneVilleFabulee2 = _interopRequireDefault(_imageFooterUneVilleFabulee);
	
	var _hamburger = __webpack_require__(62);
	
	var _hamburger2 = _interopRequireDefault(_hamburger);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SecondPage = function SecondPage() {
	    return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	            _flexContainer2.default,
	            null,
	            _react2.default.createElement(_reactHelmet2.default, { bodyAttributes: { class: 'hamburger' } }),
	            _react2.default.createElement(_sidebarLeft2.default, null),
	            _react2.default.createElement(
	                _container2.default,
	                null,
	                _react2.default.createElement(_hamburger2.default, null),
	                _react2.default.createElement(
	                    'h1',
	                    null,
	                    'Une ville fabul\xE9e'
	                ),
	                _react2.default.createElement(
	                    'p',
	                    null,
	                    'En 1616, huit ans apr\xE8s avoir \xE9tabli \xE0 Qu\xE9bec un comptoir de fourrures, Samuel de Champlain \xE9crit au roi pour lui demander de fonder, dans les basses terres de la ville, une v\xE9ritable colonie: Ludovica. Inspir\xE9 du mod\xE8le communal, l\'\xE9tablissement pr\xE9vu pour la Pointe-aux-Li\xE8vres (actuelle basse-ville) serait non seulement une halte pour les commer\xE7ants, mais une v\xE9ritable capitale digne de Saint-Denis (Paris). Au c\u0153ur de la Nouvelle-France, dans l\'enclave d\'une vall\xE9e d\'abondance, Ludovica serait le lieu d\'un immense temple d\xE9di\xE9 au R\xE9dempteur, un sanctuaire digne des plus beaux temples d\'Orient: un si\xE8ge de la foi dans le Nouveau Monde.'
	                ),
	                _react2.default.createElement(
	                    'p',
	                    null,
	                    'Tout croyant qu\'il \xE9tait en quelque chose de plus grand que lui-m\xEAme (et \xE0 cette \xE9poque les Europ\xE9ens appelaient cette chose Dieu), Champlain avait la foi. Plus de quatre cents ans plus tard, cette foi en quelque chose de plus grand que soi-m\xEAme s\'est impos\xE9e comme la source d\'un autre projet. Si Ludovica n\'a jamais vu le jour, Ludovica verrait le jour. Rien de de religieux ou de syst\xE9matique, mais quelque chose de bien enracin\xE9 qui mijote, m\xEAme au frette. On a donc \xE9crit et film\xE9 pour rappeler \xE0 bon entendeur qu\'en des temps parfois d\xE9pressionnistes, les vents de l\'int\xE9rieur peuvent encore mener au large. Mieux vaut, quand m\xEAme, savoir manier la rame.'
	                )
	            ),
	            _react2.default.createElement(_sidebarRight2.default, null)
	        ),
	        _react2.default.createElement(_imageFooterUneVilleFabulee2.default, null)
	    );
	};
	
	exports.default = SecondPage;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-une-ville-fabulee-js-0c1707bc68d2a8c02681.js